/* AstaLab 2.0 — /register (obiettivo 3). */
import { escapeHtml } from "../components/escapeHtml.js";
import { renderNoticeIfAny } from "../components/DemoModeBanner.js";
import { AUTH_PASSWORD_MIN_LENGTH, passwordPolicyHint } from "../../config/authPolicy.js";

// Round Beta-P3-3 (design D4, accettato): generazione modulo-privata INDIPENDENTE da quella di
// LoginPage.js — stesso principio, mai condivisa fra pagine diverse.
let _registerRenderGeneration = 0;

export function renderRegisterPage(container, ctx){
  const myGeneration = ++_registerRenderGeneration;
  const hashAtEntry = window.location.hash;
  function isStale(){
    return myGeneration !== _registerRenderGeneration || window.location.hash !== hashAtEntry;
  }
  container.innerHTML =
    '<div class="auth-card">' +
      '<h1>Crea un account AstaLab</h1>' +
      '<form id="registerForm">' +
        '<label class="field">Email<input type="email" id="regEmail" required autocomplete="email"></label>' +
        '<label class="field">Password (' + passwordPolicyHint() + ')<input type="password" id="regPassword" required minlength="' + AUTH_PASSWORD_MIN_LENGTH + '" autocomplete="new-password"></label>' +
        '<button type="submit" class="btn primary">Registrati</button>' +
      '</form>' +
      '<p class="hint">' + escapeHtml("Se il backend cloud non è disponibile in questo ambiente, la registrazione resterà locale a questo browser: non usare una password reale.") + '</p>' +
      '<div id="registerMsg"></div>' +
      '<p class="hint">Hai già un account? <a href="#/login">Accedi</a></p>' +
    '</div>';

  const form = container.querySelector("#registerForm");
  const msg = container.querySelector("#registerMsg");
  const submitBtn = form.querySelector('button[type="submit"]');
  // Round Beta-P3-2: stessa guardia locale di LoginPage.js — vedi il commento esteso lì. Il
  // `finally` ripristina il pulsante anche nel ramo "resta su questa pagina" (conferma email
  // pendente, nessuna sessione), dove l'utente potrebbe altrimenti trovare il form bloccato senza
  // mai essere stato spinto altrove.
  let submitting = false;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if(submitting) return;
    submitting = true;
    submitBtn.disabled = true;
    try{
      msg.innerHTML = "";
      const email = container.querySelector("#regEmail").value;
      const password = container.querySelector("#regPassword").value;
      const result = await ctx.adapter.signUp(email, password);
      if(!result.ok){
        msg.innerHTML = '<p class="errtext">' + escapeHtml(result.error) + "</p>";
        return;
      }
      // Round Beta-P3-3: primo controllo di staleness, PRIMA di proseguire nel lavoro del ramo di
      // successo — evita anche una getCurrentUser() sprecata su un render già abbandonato.
      if(isStale()) return;
      msg.innerHTML = renderNoticeIfAny(result) || '<p class="okmsg">Registrazione completata.</p>';
      // Sia il flusso demo (login immediato) sia quello reale con conferma email disattivata
      // arrivano qui con una sessione già attiva; se Supabase richiede conferma email (notice
      // presente, nessuna sessione), l'utente resta su questa pagina a leggere il messaggio invece
      // di essere spinto su una dashboard a cui non può ancora accedere.
      //
      // Round Beta-P3-4 (design D/D2, accettato): catch NARROW, dedicato SOLO a getCurrentUser() —
      // un suo rigetto è un'incertezza sulla sessione, MAI un fallimento della registrazione appena
      // riuscita (il messaggio sopra resta veritiero e invariato). Nessun retry automatico qui: solo
      // un avviso supplementare onesto + un link semplice, la Dashboard possiede il proprio
      // ricontrollo autoritativo/retry-capace al suo ingresso (round Beta-P3-4).
      let user;
      try{
        user = await ctx.adapter.getCurrentUser();
      }catch(err){
        if(isStale()) return;
        msg.innerHTML += '<p class="errtext">Non è stato possibile confermare automaticamente l\'accesso. <a href="#/dashboard">Continua</a></p>';
        return;
      }
      // Round Beta-P3-3: SECONDO controllo, obbligatorio — l'utente può lasciare la pagina proprio
      // durante questo stesso await, dopo che il primo controllo era già passato.
      if(isStale()) return;
      if(user) ctx.navigate("/dashboard");
    } finally {
      submitting = false;
      submitBtn.disabled = false;
    }
  });
}
